export default {
  defaultKpiName: 'Sales',
  title: 'Model Data',
  save: 'Save',
  warning: 'Warning',
  cannotBeUndone: 'This action cannot be undone. Are you sure?',
  abort: 'Abort',
  confirm: 'Confirm',
  mediaChannels: 'Media Channels',
  kpis: 'KPIs'
}
